import React, {Component} from 'react';
import {Grid, Row, Col} from "react-bootstrap";
import TopBreadcumb from "../../../../componentsTopsa/breadcrumbs/TopBreadcumb";
import SubHeader from "../../../../shared/sidebar/SubHeader";
import SidebarComponent from "../../../../shared/sidebar/SidebarComponent";
import Links from "../../../../utilities/linksConfig/Links";
import ReactNotify from 'react-notify';
import LinieService from "./LinieService";
import LinieTable from "./components/LinieTable";
import TrasyService from "../trasy/TrasyService";
import {TopButtonAdd} from "../../../../componentsTopsa/buttons/TopButtons";
import LinieForm from "./components/LinieForm";
import AppConfig from "../../../../AppConfig";
import axios from 'axios'
import ScrollUtilities from "../../../../utilities/ScrollUtilities";

export default class LinieContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            trasy: [],
            linie: [],
            pokazFormularz: false,
            typy: [],
            edytowana: null
        };
        this.onClickEdytuj = this.onClickEdytuj.bind(this)
        this.onClickUsun = this.onClickUsun.bind(this)
        this.onClickZapisz = this.onClickZapisz.bind(this)
    }

    componentDidMount() {
        this.pobierzLinie()
        this.pobierzTrasy()
        this.pobierzTypyTasy()
    }

    pobierzTrasy() {
        TrasyService.getTrasy().then(function (response) {
            this.setState({trasy: response.data.content})
        }.bind(this))
    }

    pobierzTypyTasy() {
        axios.get(AppConfig.HOST_API() + 'slownik/byNazwa/LINIA_TYP').then(function (response) {
            if (response.status < 300) {
                this.setState({typy: response.data})
            }
        }.bind(this))
    }

    pobierzLinie() {
        LinieService.getLinie().then(function (response) {
            this.setState({linie: response.data.content})
        }.bind(this))
    }

    onClickEdytuj(obj) {
        this.setState({edytowana: obj, pokazFormularz: true})
        ScrollUtilities.scrollToTop()
    }

    onClickUsun(obj) {
        if (window.confirm('Czy usunąc linię: ' + obj.relacja)) {
            LinieService.deleteLinia(obj.idLi).then(function (response) {
                if (response.status < 300) {
                    this.refs.notificator.success('Pomyślnie usunięto linię', "", 3000)
                    this.pobierzLinie();
                }
                else {
                    this.refs.notificator.error('Wystąpił błąd podczas usuwania linii', "", 3000)
                }
            }.bind(this))
        }
    }

    onClickZapisz(obj, czyEdycja) {
        if (czyEdycja) {
            LinieService.editLinia(this.state.edytowana.idLi, obj).then(function (response) {
                if (response.status < 300) {
                    this.refs.notificator.success('Pomyślnie edytowano linię', "", 3000)
                    this.pobierzLinie();
                }
                else {
                    this.refs.notificator.error('Wystąpił błąd podczas edytowania linii', "", 3000)
                }
            }.bind(this))

        }
        else {
            LinieService.addLinia(obj).then(function (response) {
                if ((response.status < 300)) {
                    this.refs.notificator.success('Pomyślnie dodano linię', "", 3000)
                    this.pobierzLinie();
                }
                else {
                    this.refs.notificator.error('Wystąpił błąd podczas dodawania linii', "", 3000)
                }
            }.bind(this))
        }
        this.zamknijFormularz()
    }

    zamknijFormularz() {
        this.setState({pokazFormularz: false, edytowana: null})
    }

    render() {

        return (
            <SidebarComponent links={Links.getKonfiguracjaLinks} currentLink={this.props.match.path} history={this.props.history}
                              collapsedLinks={this.props.collapsedLinks}
                              handleClickToogleSidebar={(module) => this.props.handleClickToogleSidebar(module)}>
                <Grid fluid={true} id={'LinieContainer'}>
                    <ReactNotify ref='notificator'/>
                    <Row>
                        <Col sm={12}>
                            <div id="subheader">
                                <TopBreadcumb links={[{addressUrl: '/konfiguracja', text: 'Konfiguracja'}, {
                                    addressUrl: '/konfiguracja/zarzadzanie-trasami',
                                    text: 'Zarządzanie trasami'
                                }, {addressUrl: '/konfiguracja/zarzadzanie-trasami/linie', text: 'Linie'}]}/>
                                <SubHeader currentLink={this.props.match.path} obecnyKalendarz={this.props.obecnyKalendarz}
                                           history={this.props.history}/>
                            </div>
                        </Col>
                        <Col xs={12}>
                            {
                                this.state.pokazFormularz ?
                                    <LinieForm trasy={this.state.trasy} typy={this.state.typy}
                                               handleClickZapisz={this.onClickZapisz}
                                               handleClickAnuluj={() => {
                                                   this.setState({pokazFormularz: false, edytowana: null})
                                               }}
                                               edytowana={this.state.edytowana}/>
                                    :
                                    <div className={'pull-right'}>
                                        <TopButtonAdd onClick={() => {
                                            this.setState({pokazFormularz: true});
                                            ScrollUtilities.scrollToTop()
                                        }}/>
                                    </div>
                            }
                        </Col>
                        <Col xs={12}>
                            <LinieTable data={this.state.linie}
                                        trasy={this.state.trasy}
                                        handleEdytuj={this.onClickEdytuj}
                                        handleUsun={this.onClickUsun}
                            />
                        </Col>
                    </Row>
                </Grid>
            </SidebarComponent>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/konfiguracja/trasyConfig/linie/LinieContainer.js